import {
  getExperiments,
  trackEvent,
  validateViewForEmailCapture,
  setCaptureModalCookie,
} from '@components/EmailCapture/utils';

export const state = {
  modalShown: false,
  experiments: undefined,
  subscribed: false,
};

export const getters = {
  subscribed(state) {
    return state.subscribed;
  },

  modalShown(state) {
    return state.modalShown;
  },
};

export const actions = {
  trackEvent({ state }, eventName) {
    const { experiments } = state;
    trackEvent(eventName, experiments);
  },

  closeModal({ commit, dispatch }) {
    setCaptureModalCookie();
    dispatch('trackEvent', 'emailCaptureModalClose');
    commit('setModalShown', false);
  },

  openModal({ commit, dispatch }) {
    dispatch('trackEvent', 'emailCaptureModalView');
    commit('setModalShown', true);
  },

  runEmailCapture({ dispatch, commit }) {
    const showEmailCapture = validateViewForEmailCapture(window.cdata);

    if (!showEmailCapture) {
      return;
    }

    const experiments = getExperiments();
    commit('setExperiments', experiments);

    let delay = (experiments.new_modal_delay || { delay: 3000 }).delay;

    modalTimeout = setTimeout(() => {
      dispatch('openModal');
      clearTimeout(modalTimeout);
    }, delay);
  },
};

let modalTimeout;
export const mutations = {
  setSubscribed(state, val) {
    // Just in case the customer uses the footer form before the modal is displayed
    clearTimeout(modalTimeout);
    state.subscribed = !!val;
  },

  setModalShown(state, val) {
    state.modalShown = !!val;
  },

  setExperiments(state, experiments) {
    state.experiments = experiments;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
